import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../../themes'

export const OrderModalStyle = styled.div`
  height: 616px;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  color: ${NATIVE_BASE_COLORS.TEXT[900]};

  .order-modal__title {
    padding-bottom: 32px;
    margin: 0;
    width: 100%;
    text-align: center;
  }

  .order-modal__top {
    position: relative;
    display: flex;
    justify-content: center;
  }

  .order-modal__divider {
    height: 8px;
    width: 100%;
    border-top: 1px solid ${NATIVE_BASE_COLORS.MUTED[200]};
    transform: translateY(6px);
  }

  .order-modal__list {
    height: 100%;
    padding: 16px 0;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0px;
    }
  }

  .order-modal__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: NunitoSansRegular;
  }
  
  .order-modal__counter {
    display: flex;
    align-items: center;
    gap: 16px;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;
      border: none;
      cursor: pointer;

      img {
        width: 24px;
        height: 24px;
      }
    }

    span {
      width: 32px;
      text-align: center;
    }
  }

  .order-modal__bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-self: flex-end;
    gap: 16px;
    background-color: ${COLOR.WHITE};
    padding-top: 16px;

    button {
      box-sizing: border-box;
      width: 160px;
      height: 40px;
      padding: 10px 12px;
      border-radius: 4px;
      font-family: NunitoSansBold;
      font-size: ${FONT_SIZE.TN};
      cursor: pointer;
    }

    &__button--back {
        border: 1px solid ${NATIVE_BASE_COLORS.MUTED[300]};
        background: none;
        color: ${NATIVE_BASE_COLORS.TEXT[900]};
      }

    &__button--add {
      border: 1px solid ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : COLOR.BLACK_1}
    }
  }
`
